import {
  UPDATE__SURVEY__PREVIEW_DATA,
  TOGGLE_SURVEY__PREVIEW_LIST_LOADING,
  MY_SURVEY__PREVIEW_LIST_ERROR,
} from "../actions/dataEntrySurveyPreviewActions";

const initState = {
  name: "Data Entry Survey Preview",
  surveyPreview: {
    loading: true,
    users: [],
    error: null,
    totalUsers: 0,
    totalCompleted: 0,
    percentageCompleted: 0,
    template: null,
    name: null,
    notes: null,
    surveyResults: [],
  },
};

const dataEntrySurveyPreviewReducer = (state = initState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case UPDATE__SURVEY__PREVIEW_DATA:
      newState.surveyPreview = {
        ...newState.surveyPreview,
        ...action.payload.value,
      };
      break;
    case TOGGLE_SURVEY__PREVIEW_LIST_LOADING:
      newState.surveyPreview.loading = action.payload.value;
      break;
    case MY_SURVEY__PREVIEW_LIST_ERROR:
      newState.surveyPreview.error = action.payload.value;
      break;
    default:
      break;
  }
  return newState;
};

export default dataEntrySurveyPreviewReducer;
